import React from 'react';
import { formatJJMMAAAA, formatNombre } from '../utils/eau3mois';

/** Sous-titre d'un graphique par système (sous_titre du Shiny). */
export function SousTitreSysteme({ info, coupure, rcp }) {
  return (
    <p className="ig-tableau-sous-titre" style={{ color: '#555', fontSize: 13 }}>
      {info.systeme}, {info.modalite} | coupure SAFRAN→DRIAS le {formatJJMMAAAA(coupure)} |{' '}
      {info.nTraj} trajectoires = {info.nCombinaisons} combinaisons modèle × RCP (rcp {rcp}) ×{' '}
      {info.annees.length} années
      <br />
      Bretagne — {formatNombre(info.quantite, 0)} {info.uniteQuantite}, {info.nMailles} mailles SAFRAN
    </p>
  );
}

/** Notes de lecture reprises du panneau d'information de l'app Shiny. */
export function NotesSysteme({ info, grandeur, realiseJusquau }) {
  return (
    <div style={{ fontSize: 13, color: '#555', lineHeight: 1.5, marginTop: 8 }}>
      {realiseJusquau && <p>Réalisé SAFRAN observé jusqu'au {formatJJMMAAAA(realiseJusquau)}.</p>}
      {info.famille === 'Élevage' && (
        <p>Cheptel supposé homogène : tout l'effectif est conduit selon la modalité sélectionnée.
          Effectifs répartis à parts égales entre les mailles du département.</p>
      )}
      {info.famille === 'Grandes cultures' && (
        <p>Hypothèse : toute la surface de la région est conduite selon le système sélectionné.</p>
      )}
      {grandeur === 'irrigation' && (
        <p><b>Irrigation théorique :</b> volume qu'il faudrait apporter pour maintenir la réserve
          utile, pas un volume effectivement prélevé. Le maïs breton est très majoritairement
          conduit en sec.</p>
      )}
      <p><b>Attention :</b> pour une culture le besoin est une demande en eau de la plante
        (évapotranspiration, largement couverte par la pluie) ; pour l'élevage et les résidents
        c'est un prélèvement réel. Les volumes de ces familles ne sont pas comparables entre eux.</p>
    </div>
  );
}

/** Notes du total territoire (hypothèses à annoncer du README du Shiny). */
export function NotesTotal({ grandeur }) {
  return (
    <div style={{ fontSize: 13, color: '#555', lineHeight: 1.5, marginTop: 8 }}>
      <p>Aires : MAXIMUM de chaque poste sur l'ensemble des trajectoires. Leur somme dépasse le
        maximum du total, les postes ne culminant pas sur la même trajectoire. Les pointillés
        donnent les statistiques du total sommé trajectoire par trajectoire.</p>
      {grandeur === 'irrigation' ? (
        <p>L'irrigation du maïs est prise à 5 % du besoin de la plante (hypothèse de travail) : la
          part agricole du total en dépend entièrement, la hiérarchie affichée n'est donc pas encore
          un résultat.</p>
      ) : (
        <p><b>Attention :</b> le besoin en eau de la culture est une évapotranspiration, largement
          couverte par la pluie : l'additionner à des prélèvements réels n'a pas de sens physique.</p>
      )}
    </div>
  );
}
